<template>
  <div>
    <cashflow-app/>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import CashflowApp from './CashflowApp.vue';

export default {
  name: 'DemoCashflowApp',
  components: {
    CashflowApp,
  },

  async created() {
    this.setCustomerDetails({
      firstName: 'עידן',
      secondMemberName: 'עידן',
      numberOfMembers: 2,
      householdName: 'עידן',
    });
  },
  methods: {
    ...mapMutations('session', ['setCustomerDetails']),
  },
};
</script>
